export default __webpack_public_path__ + "static/media/apache-kafka.84d986f9.png";